import { render, staticRenderFns } from "./TransportationEmissions.vue?vue&type=template&id=0ef99dea&scoped=true"
import script from "./TransportationEmissions.vue?vue&type=script&lang=js"
export * from "./TransportationEmissions.vue?vue&type=script&lang=js"
import style0 from "./TransportationEmissions.vue?vue&type=style&index=0&id=0ef99dea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef99dea",
  null
  
)

export default component.exports